export type FollowUpAction = 'queue' | 'steer'
export type ComposerAction =
  | 'send'
  | 'queue'
  | 'steer'
  | 'stop'
  | 'update'
  | 'resume'

// A settings toggle for the default is deferred; Cmd+Enter is the alternate.
export const DEFAULT_FOLLOW_UP: FollowUpAction = 'queue'

/** User-facing verbs; "steer" stays the internal and API name. */
export const FOLLOW_UP_VERB: Record<FollowUpAction, string> = {
  queue: 'queue',
  steer: 'send now',
}

export function alternateFollowUp(action: FollowUpAction): FollowUpAction {
  return action === 'queue' ? 'steer' : 'queue'
}

/** What the composer's primary button, Enter, and Cmd+Enter do right now. */
export function resolveComposerAction({
  isRunActive,
  hasText,
  alternate,
  editingId,
  held,
  defaultFollowUp,
}: {
  isRunActive: boolean
  /** Text or attachments the composer could send. */
  hasText: boolean
  /** Cmd or Ctrl is held, or the user pressed Cmd+Enter or Cmd-clicked. */
  alternate: boolean
  editingId: string | null
  held: boolean
  defaultFollowUp: FollowUpAction
}): ComposerAction {
  if (editingId) return 'update'
  if (!hasText) {
    if (isRunActive) return 'stop'
    return held ? 'resume' : 'send'
  }
  if (!isRunActive) return 'send'
  return alternate ? alternateFollowUp(defaultFollowUp) : defaultFollowUp
}
